import { createLoginPage } from './kernelLogin';
import NexoraLogo from '../components/NexoraLogo';

export default createLoginPage({
  brand: {
    mode: 'svg',
    mark: <NexoraLogo />,
  },
  demoHint: false,
});
